import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function CaseCourtSurgeryReportForm({ location }) {
  console.log('CaseCourtSurgeryReportForm rendered: ', location)

  let init = {
    settlementGroup: [],
    plaintiffLastName: '',
    plaintiffFirstName: '',
    caseTitle: '',
    plaintiffAge: '',
    surgeryDateFrom: '',
    surgeryDateTo: '',
    productLotDetails: '',
    numberOfSurgeries: '',
    suiRelated: '',
    popRelated: '',
    hasInjury: '',
    manufacturer: [],
    productGroup: [],
    product: [],
  }

  const navigate = useNavigate()
  init = initialFormValues('CaseCourtSurgeryReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('CaseCourtSurgeryReportForm', navigate, inputs, 'case_query.case_query_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Case, Court, and Surgery Report' />
            <tbody>
              <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} defaultValue={inputs.settlementGroup} />
              <TextInput label='Plaintiff Last Name' name='plaintiffLastName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffLastName} />
              <TextInput label='Plaintiff First Name' name='plaintiffFirstName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffFirstName} />
              <TextInput label='Case Title' name='caseTitle' handleInputChange={handleInputChange} defaultValue={inputs.caseTitle} />
              <TextInput label='Plaintiff Age (As of data loading)' name='plaintiffAge' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffAge} />
              <DateRangeInput label='Surgery Date' name='surgeryDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.surgeryDateFrom} defaultValueTo={inputs.surgeryDateTo} />
              <TextInput label='Product/Lot Details' name='productLotDetails' handleInputChange={handleInputChange} defaultValue={inputs.productLotDetails} />
              <TextInput label='Number of Surgeries' name='numberOfSurgeries' handleInputChange={handleInputChange} defaultValue={inputs.numberOfSurgeries} />
              <tr>
                <td><b>SUI Related</b></td>
                <td> <Input
                  type="select"
                  name="suiRelated"
                  onChange={handleInputChange}
                  defaultValue={inputs.suiRelated}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <tr>
                <td><b>POP Related</b></td>
                <td> <Input
                  type="select"
                  name="popRelated"
                  onChange={handleInputChange}
                  defaultValue={inputs.popRelated}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <tr>
                <td><b>Has Injury?</b></td>
                <td> <Input
                  type="select"
                  name="hasInjury"
                  onChange={handleInputChange}
                  defaultValue={inputs.hasInjury}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <CustomSelectListInput label="Manufacturer" handleChange={handleInputChange} modelName="BosSci" entityName="manufacturer" name='manufacturer' multiple={true} defaultValue={inputs.manufacturer} />
              <CustomSelectListInput label="Product Group" handleChange={handleInputChange} modelName="BosSci" entityName="product_group" name='productGroup' multiple={true} defaultValue={inputs.productGroup} />
              <CustomSelectListInput label="Product" handleChange={handleInputChange} modelName="BosSci" entityName="product" name='product' multiple={true} defaultValue={inputs.product} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

